import { render } from "./Disbursements.vue?vue&type=template&id=2ef13d2a&scoped=true"
import script from "./Disbursements.vue?vue&type=script&lang=js"
export * from "./Disbursements.vue?vue&type=script&lang=js"

import "./Disbursements.vue?vue&type=style&index=0&id=2ef13d2a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef13d2a"]])

export default __exports__